import React, { memo, useMemo, useContext } from 'react';
import { context as Context } from '@gp/components/Context';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import DataTime from '@gp/components/DataTime';
// @ts-ignore
import { LineEchart } from '@gp/components/CustomEchart';
import { getEChartOpt, tootipFormatter } from './utils/common';
import './index.scss';

interface LineEchartConProps extends IBaseProps {
  [keyName: string]: any;
}

function LineEchartCon(props: LineEchartConProps) {
  const {} = props;

  const {
    loading,
    dataList: data,
    updateTime,
  }: HeadcountsContextTypes = useContext(Context) || {};

  const options = useMemo(() => {
    const option = getEChartOpt(data);
    return {
      ...option,
      tooltip: {
        ...option.tooltip,
        formatter: tootipFormatter,
      },
    };
  }, [data]);

  return (
    <section className="dbg-studio-overall-details-finance-financials-line-content">
      {loading ? (
        <Loading loading style={{height: 260}} />
      ) : !data || !data?.dataList?.length ? (
        <NoData height={200} constomStyle={{ fontSize: 14 }} />
      ) : (
        <>
          {/* <DataTime
            className="dbg-studio-overall-details-finance-financials-update-time"
            dateType="Month"
            date={updateTime}
          /> */}
          <LineEchart
            options={options}
            // xAxisData={}
            fontSize={14}
            // tootipFormatter={tootipFormatter}
            axisPointerType="line"
            style={{ height: '320px', width: '100%' }}
          />
        </>
      )}
    </section>
  );
}

LineEchartCon.defaultProps = {};

export default memo(LineEchartCon);
